import React, { useState, useEffect } from "react";
import logo from "../images/svgs/logo.svg";
import { Navbar, Nav, Button, Image, Container } from "react-bootstrap";
import { Fade as Hamburger } from "hamburger-react";
import { scrollToTop, login, register } from "../functions/functions";
import { AnalyticsHandle } from "../components/AnalyticsHandle";

function MenuBar() {
  const [content, setContent] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { logAnalyticsEvent } = AnalyticsHandle();

  const handleNavClick = (linkName) => {
    logAnalyticsEvent("menu_click", {
      link_name: linkName,
      timestamp: new Date().toISOString(),
    });
  };

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  if (!content) return <div></div>;
  const { navbar } = content;

  return (
    <>
      <Navbar id="navbar" expand="lg" className="p-0" sticky="top">
        <Container className="menubar" fluid>
          <Navbar.Brand href="/">
            <Image
              src={logo}
              alt="Logo eGodziny"
              onClick={() => {
                scrollToTop();
                handleNavClick("logo");
              }}
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <Hamburger direction="right" color="white"></Hamburger>
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto align-items-center">
              <Nav.Link
                href="/funkcje"
                className="text-white"
                onClick={() => {
                  handleNavClick("features");
                }}
              >
                Funkcje
              </Nav.Link>

              <div className="mega-menu-item">
                <Nav.Link
                  className="text-white mega-menu-trigger"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 991) {
                      setActiveDropdown(
                        activeDropdown === "industries" ? null : "industries",
                      );
                    }
                    handleNavClick("industries_menu");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Branże
                  <i className="material-icons mega-menu-arrow">
                    keyboard_arrow_down
                  </i>
                </Nav.Link>
                <div
                  className={`mega-menu-dropdown ${activeDropdown === "industries" ? "show" : ""}`}
                >
                  <div className="mega-menu-section">
                    <h6>Rozwiązania dla branż</h6>
                    <a
                      href="/praca-tymczasowa-i-outsourcing"
                      onClick={() => handleNavClick("industry_temp_work")}
                    >
                      Praca Tymczasowa i Outsourcing
                    </a>
                    <a
                      href="/inzynieria-i-budownictwo"
                      onClick={() => handleNavClick("industry_engineering")}
                    >
                      Inżynieria i Budownictwo
                    </a>
                  </div>
                </div>
              </div>

              <Nav.Link
                href="/cennik"
                className="text-white"
                onClick={() => {
                  handleNavClick("pricing");
                }}
              >
                {navbar.pricing}
              </Nav.Link>

              <Nav.Link
                href="/kalkulator-oszczednosci"
                className="text-white"
                onClick={() => {
                  handleNavClick("savings_calculator");
                }}
              >
                Kalkulator oszczędności
              </Nav.Link>

              <div className="mega-menu-item">
                <Nav.Link
                  className="text-white mega-menu-trigger"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.innerWidth <= 991) {
                      setActiveDropdown(
                        activeDropdown === "about" ? null : "about",
                      );
                    }
                    handleNavClick("about_menu");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {navbar.about}
                  <i className="material-icons mega-menu-arrow">
                    keyboard_arrow_down
                  </i>
                </Nav.Link>
                <div
                  className={`mega-menu-dropdown ${activeDropdown === "about" ? "show" : ""}`}
                >
                  <div className="mega-menu-section">
                    <h6>Firma</h6>
                    <a
                      href="/o-nas#misja-wartosci"
                      onClick={(e) => {
                        if (window.location.pathname === "/o-nas") {
                          e.preventDefault();
                          const element =
                            document.getElementById("misja-wartosci");
                          if (element) {
                            const offset = 100;
                            const elementPosition =
                              element.getBoundingClientRect().top +
                              window.pageYOffset;
                            window.scrollTo({
                              top: elementPosition - offset,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Wartości i Misja
                    </a>
                    <a
                      href="/o-nas#historia"
                      onClick={(e) => {
                        if (window.location.pathname === "/o-nas") {
                          e.preventDefault();
                          const element = document.getElementById("historia");
                          if (element) {
                            const offset = 100;
                            const elementPosition =
                              element.getBoundingClientRect().top +
                              window.pageYOffset;
                            window.scrollTo({
                              top: elementPosition - offset,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Historia
                    </a>
                    <a
                      href="/o-nas#zespol"
                      onClick={(e) => {
                        if (window.location.pathname === "/o-nas") {
                          e.preventDefault();
                          const element = document.getElementById("zespol");
                          if (element) {
                            const offset = 100;
                            const elementPosition =
                              element.getBoundingClientRect().top +
                              window.pageYOffset;
                            window.scrollTo({
                              top: elementPosition - offset,
                              behavior: "smooth",
                            });
                          }
                        }
                      }}
                    >
                      Zespół
                    </a>
                  </div>
                </div>
              </div>

              <Nav.Link
                href="/kontakt"
                className="text-white"
                onClick={() => {
                  handleNavClick("contact");
                }}
              >
                {navbar.contact}
              </Nav.Link>

              <Nav.Link
                href="/blog"
                className="text-white"
                onClick={() => {
                  handleNavClick("blog");
                }}
              >
                {navbar.blog}
              </Nav.Link>

              <Nav.Link
                href="/case-study"
                className="text-white"
                onClick={() => {
                  handleNavClick("case_study");
                }}
              >
                Case Study
              </Nav.Link>
            </Nav>

            <Nav className="ms-auto align-items-center">
              <Nav.Link className="no-hover-bg">
                <Button
                  className="login-button hidden-in-menu"
                  onClick={() => {
                    login();
                    handleNavClick("login");
                  }}
                >
                  Zaloguj się
                </Button>
              </Nav.Link>
              <Nav.Link className="no-hover-bg">
                <Button
                  className="login button-default hidden-in-menu register-button"
                  onClick={() => {
                    register();
                    handleNavClick("register");
                  }}
                >
                  {navbar.create_account}
                </Button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default MenuBar;
